import { Component, OnInit, Inject,  } from '@angular/core';
import { ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { WebnarService } from '../../../services/webnar.service';
import { Webnar } from '../../../models/webnar';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-webnar-dialog',
  templateUrl: './webnar-dialog.component.html',
  styleUrls: ['./webnar-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' }
  ]
})
export class WebnarDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update
  public spinner: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private _webnarService: WebnarService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: Webnar
  ) { }

  ngOnInit() {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = "" + this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Novo Webnar"
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)
  }

  insert() {
    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Webnar = this.createEntity(this.entityForm.value);

      this._webnarService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert webnar error: " + error)
          let msgError: string = this._webnarService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {

      this.spinner = true;
      let entity: Webnar = this.createEntity(this.entityForm.value);

      this._webnarService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("webnar update error: " + JSON.stringify(error))
          let msgError: string = this._webnarService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity(data: any): Webnar {
    let entity = new Webnar();
    entity.id = data.id;
    entity.name = data.name;
    entity.name_en = data.name_en;
    entity.url = data.url;

    if (!data.created)
      entity.created = new Date();
    else
      entity.created = data.created;

    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.name_en.setValue(data.name_en);
    form.controls.url.setValue(data.url);

    if (data.created) {
      let dt: any = data.created
      form.controls.created.setValue(new Date(dt.seconds * 1000));
    }


  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      name_en: new FormControl(''),
      url: new FormControl(''),
      created: new FormControl('')
    });
    return form
  }


}

